import { Controller } from 'react-hook-form';

function FormRegistrarPraticaMassa({
    register,
    control,
    errors,
    listaPresencaSelected,
    setListaPresencaSelected,
    fotosSelected,
    setFotosSelected,
    idPrefix = 'pratica_massa',
    arquivosHint = 'Os mesmos arquivos serão aplicados a todos os usuários selecionados',
}) {
    const listaPresencaId = `${idPrefix}_lista_presenca`;
    const fotosId = `${idPrefix}_fotos`;

    return (
        <div className="row g-4">
            <div className="col-12">
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-primary">
                        <h6 className="mb-0 text-white fw-bold">
                            <i className="bi bi-info-circle me-2"></i>
                            Informações do Treinamento
                        </h6>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                    Data do Treinamento Prático
                                </label>
                                <input
                                    type="datetime-local"
                                    className={`form-control ${errors.data_treinamento ? 'is-invalid' : ''}`}
                                    {...register('data_treinamento', { required: true })}
                                />
                                {errors.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                    Local do Treinamento
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.local_treinamento ? 'is-invalid' : ''}`}
                                    {...register('local_treinamento', { required: true })}
                                />
                                {errors.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                            </div>
                            <div className="col-12">
                                <label className="form-label fw-semibold">
                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                    Instrutor Responsável
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.gestor ? 'is-invalid' : ''}`}
                                    {...register('gestor', { required: true })}
                                />
                                {errors.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-primary">
                        <h6 className="mb-0 text-white fw-bold">
                            <i className="bi bi-cloud-upload me-2"></i>
                            Arquivos do Treinamento
                        </h6>
                        <small className="text-white">{arquivosHint}</small>
                    </div>
                    <div className="card-body">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                    Lista de Presença
                                </label>
                                <div className="upload-area">
                                    <label
                                        htmlFor={listaPresencaId}
                                        className={`upload-label ${listaPresencaSelected ? 'uploaded' : ''}`}
                                    >
                                        <div className="upload-content">
                                            <i className={`bi ${listaPresencaSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                            <div className="upload-text">
                                                <div className="fw-semibold">
                                                    {listaPresencaSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                </div>
                                                <small className="text-muted">PDF ou Imagem</small>
                                            </div>
                                        </div>
                                        {listaPresencaSelected && (
                                            <div className="upload-badge">
                                                <span className="badge bg-success">
                                                    <i className="bi bi-check me-1"></i>
                                                    1 arquivo
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                    <Controller
                                        control={control}
                                        name="lista_presenca"
                                        rules={{ required: true }}
                                        render={({ field: { onChange, onBlur, ref } }) => (
                                            <input
                                                id={listaPresencaId}
                                                type="file"
                                                style={{ display: 'none' }}
                                                accept=".pdf,image/*"
                                                onBlur={onBlur}
                                                ref={ref}
                                                onChange={(e) => {
                                                    const files = e.target.files;
                                                    onChange(files);
                                                    setListaPresencaSelected(files && files.length > 0);
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                {errors.lista_presenca && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    <i className="bi bi-images me-1 text-info"></i>
                                    Fotos do Treinamento
                                </label>
                                <div className="upload-area">
                                    <label
                                        htmlFor={fotosId}
                                        className={`upload-label ${fotosSelected ? 'uploaded' : ''}`}
                                    >
                                        <div className="upload-content">
                                            <i className={`bi ${fotosSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                            <div className="upload-text">
                                                <div className="fw-semibold">
                                                    {fotosSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                </div>
                                                <small className="text-muted">Múltiplas imagens</small>
                                            </div>
                                        </div>
                                        {fotosSelected && (
                                            <div className="upload-badge">
                                                <span className="badge bg-success">
                                                    <i className="bi bi-check me-1"></i>
                                                    Arquivos selecionados
                                                </span>
                                            </div>
                                        )}
                                    </label>
                                    <Controller
                                        control={control}
                                        name="fotos"
                                        rules={{ required: true }}
                                        render={({ field: { onChange, onBlur, ref } }) => (
                                            <input
                                                id={fotosId}
                                                type="file"
                                                style={{ display: 'none' }}
                                                multiple
                                                accept="image/*"
                                                onBlur={onBlur}
                                                ref={ref}
                                                onChange={(e) => {
                                                    const files = e.target.files;
                                                    onChange(files);
                                                    setFotosSelected(files && files.length > 0);
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                {errors.fotos && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormRegistrarPraticaMassa;
